/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: PublicLayout.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-AUTH
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * PublicLayout - Frontend UI module: PublicLayout.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Полноэкранный outlet: layout задаёт каждая публичная страница.
 * END_CHANGE_SUMMARY
 */

import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';

/* START_METHOD_PublicLayout */
/* START_CONTRACT: PublicLayout
 * PURPOSE: Layout публичных страниц (login/register): минимальная оболочка viewport.
 * INPUTS: нет (рендерит Outlet).
 * OUTPUTS: { JSX.Element }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-AUTH
 * END_CONTRACT: PublicLayout
 */
export default function PublicLayout() {
  return (
    <Box component="main" sx={{ minHeight: '100vh' }}>
      <Outlet />
    </Box>
  );
}
/* END_METHOD_PublicLayout */
